import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../../context/page-context';
import type { TeamMemberApiResponse } from '../../../types';
import { useSwapOwner } from '../../hooks/use-swap-owner';

export function SwapOwnerModal({
  member,
  isOpen,
  closeModal,
}: {
  member: TeamMemberApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const { mutate: swapOwner, isPending, reset } = useSwapOwner();

  const handleClose = () => {
    if (isPending) {
      return;
    }
    reset();
    closeModal();
  };

  const handleSubmit = () => {
    if (!member) {
      return;
    }

    swapOwner(member.id, {
      onSuccess: handleClose,
      onError: () => notificationHandler.error(),
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      primaryAction={{
        text: t('buttons:continue'),
        danger: true,
        onClick: handleSubmit,
        disabled: isPending,
        loading: isPending,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: handleClose,
        disabled: isPending,
      }}
    >
      <Modal.Header>
        {t('features:account.components.modals.swap_owner_modal.header', {
          name: member?.name ?? '',
        })}
      </Modal.Header>
      <Modal.Body>
        <Text>
          {t('features:account.components.modals.swap_owner_modal.body', {
            name: member?.name ?? '',
          })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
